<!-- template html -->
<template>
  <div
    v-if="thankYouNoteLoader"
    class="gt-groupcard-loader position-fixed"
    style="z-index: 999999999"
  >
    <img
      :src="$getAssetUrlPlugin('siteres/gt-loader.gif')"
      alt="Loading"
    />
  </div>
  <!--Thank you note present details Gift Recepient-->
  <div class="thankYou-tab-content" v-if="thankYouPresent && tynData != null">
    <div class="thankYou-status" v-if="tynData.SendByEmail">
      <p>
        Thank you note sent to
        {{ this.tynData.Contributers }} group members. <br />
        <span v-html="tynData.Date"></span>
      </p>
    </div>
    <div class="share-link">
      <input
        type="text"
        :value="tynData.NoteURL"
        readonly
        @click="copyGifturl"
      />
      <button @click="copyGifturl" id="btnCopyUrl">Copy</button>
    </div>
    <div class="thankYou-main text-center">
      <div class="thankYou-header">
        <svg
          width="229"
          height="33"
          viewBox="0 0 229 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.02939 32.6553C13.7786 32.6553 17.6403 28.7595 17.6403 24.0444V6.62133H14.2237V8.43168C14.2237 8.43168 12.2758 6.38032 8.99536 6.38032C4.14412 6.38032 0.419922 10.2406 0.419922 15.0933C0.419922 19.9445 4.14412 23.7708 8.99678 23.7708C12.2758 23.7708 14.2237 21.7208 14.2237 21.7208V24.0458C14.2269 24.7288 14.0947 25.4056 13.8348 26.0371C13.5749 26.6687 13.1923 27.2425 12.7094 27.7254C12.2264 28.2082 11.6525 28.5906 11.0208 28.8503C10.3892 29.1101 9.71234 29.2421 9.02939 29.2387C7.62874 29.2387 6.29613 28.7255 5.34063 27.7346L2.94761 30.1262C4.55383 31.7664 6.70725 32.6553 9.02939 32.6553ZM8.99536 20.3542C6.12601 20.3542 3.83649 17.93 3.83649 15.0933C3.83649 12.2225 6.12601 9.79689 8.99678 9.79689C11.8661 9.79689 14.2563 12.2225 14.2563 15.0933C14.2563 17.9286 11.8661 20.3542 8.99678 20.3542H8.99536ZM21.58 23.5326H24.9965V14.0343C25.0986 11.6427 26.943 9.62535 29.3005 9.62535C30.1894 9.62535 31.0443 9.93299 31.7616 10.4122L33.0588 7.13169C31.991 6.62733 30.8231 6.37049 29.6422 6.38032C26.4652 6.38032 24.9965 8.63441 24.9965 8.63441V6.62133H21.58V23.534V23.5326ZM41.9773 23.7708C46.7605 23.7708 50.5541 19.9445 50.5541 15.0933C50.5541 10.2066 46.7605 6.38032 41.9773 6.38032C37.1941 6.38032 33.4004 10.208 33.4004 15.0933C33.4004 19.9445 37.1941 23.7708 41.9773 23.7708ZM41.9773 20.3542C39.1079 20.3542 36.817 17.7925 36.817 15.0933C36.817 12.2225 39.21 9.79689 41.9773 9.79689C44.7446 9.79689 47.1376 12.2225 47.1376 15.0933C47.1376 17.9286 44.7105 20.3542 41.9773 20.3542ZM61.4886 23.7708C66.2732 23.7708 69.3481 20.6619 69.3481 15.8787V6.61991H65.9315V16.1523C65.9315 18.8855 64.2218 20.6278 61.4886 20.6278C58.7553 20.6278 57.047 18.8841 57.047 16.1523V6.61991H53.6305V15.8787C53.6305 20.6619 56.7068 23.7708 61.4886 23.7708ZM73.2807 32.4157H76.6973V21.7194C76.6973 21.7194 78.6451 23.7694 81.9256 23.7694C86.7088 23.7694 90.501 19.9431 90.501 15.0578C90.501 10.2052 86.7088 6.37891 81.9242 6.37891C78.6451 6.37891 76.6973 8.42885 76.6973 8.42885V6.61991H73.2807V32.4157ZM81.9242 20.3542C78.9868 20.3542 76.6632 17.9966 76.6632 15.0593C76.6632 12.2239 78.9868 9.79689 81.9256 9.79689C84.863 9.79689 87.0845 12.2225 87.0845 15.0593C87.0845 17.9966 84.863 20.3542 81.9242 20.3542Z"
            fill="black"
          />
          <path
            d="M32.4562 24.7617L32.8631 25.1558C35.3237 27.531 38.614 28.8524 42.0339 28.8389C45.4534 28.852 48.7431 27.5307 51.2033 25.1558L51.6102 24.7617L54.1152 27.1916L53.6828 27.6112C50.5573 30.6286 46.3782 32.3079 42.0339 32.2923C37.6891 32.3084 33.5094 30.629 30.3836 27.6112L29.9512 27.1916L32.4562 24.7617Z"
            fill="white"
          />
          <path
            d="M97.0953 23.3631H100.512V9.62593H103.621V6.37948H100.512V0H97.0953V6.38232H93.9863V9.62876H97.0953V23.3631ZM114.16 23.5686C118.941 23.5686 122.734 19.7409 122.734 14.8897C122.734 10.003 118.941 6.17675 114.158 6.17675C109.375 6.17675 105.581 10.0044 105.581 14.8897C105.581 19.7409 109.375 23.5686 114.158 23.5686H114.16ZM114.16 20.1521C111.289 20.1521 108.999 17.5889 108.999 14.8897C108.999 12.0189 111.391 9.59332 114.16 9.59332C116.926 9.59332 119.317 12.0189 119.317 14.8897C119.317 17.725 116.893 20.1507 114.158 20.1507L114.16 20.1521ZM133.909 32.4503C138.658 32.4503 142.519 28.556 142.519 23.8408V6.41634H139.102V8.2267C139.102 8.2267 137.156 6.17675 133.875 6.17675C129.024 6.17675 125.298 10.0385 125.298 14.8897C125.298 19.7409 129.024 23.5686 133.875 23.5686C137.156 23.5686 139.102 21.5173 139.102 21.5173V23.8422C139.105 24.5251 138.973 25.2018 138.713 25.8333C138.453 26.4647 138.071 27.0385 137.588 27.5213C137.105 28.0041 136.532 28.3865 135.9 28.6464C135.269 28.9062 134.592 29.0383 133.909 29.0351C132.508 29.0351 131.176 28.5219 130.219 27.5324L127.827 29.9226C129.434 31.5628 131.586 32.4517 133.909 32.4517V32.4503ZM133.875 20.1507C131.004 20.1507 128.715 17.7264 128.715 14.8897C128.715 12.0189 131.004 9.59332 133.875 9.59332C136.744 9.59332 139.137 12.0189 139.137 14.8897C139.137 17.725 136.744 20.1507 133.875 20.1507ZM154.234 23.5686C155.373 23.5726 156.502 23.3478 157.552 22.9075C158.603 22.4672 159.554 21.8204 160.35 21.0055L157.855 18.5799C156.864 19.6049 155.601 20.1507 154.234 20.1507C151.945 20.1507 149.895 18.6139 149.347 16.3244H162.484C162.484 9.86693 159.017 6.17675 154.234 6.17675C149.451 6.17675 145.691 10.0044 145.691 14.8897C145.691 19.7409 149.451 23.5686 154.234 23.5686ZM149.347 13.0779C150.065 11.0294 151.739 9.59332 154.131 9.59332C156.522 9.59332 158.368 11.1315 158.88 13.0794H149.347V13.0779ZM167.647 23.3631H171.063V9.62593H174.172V6.37948H171.063V0H167.647V6.38232H164.538V9.62876H167.647V23.3631ZM177.071 23.3291H180.488V14.446C180.488 11.7467 182.913 9.52669 185.613 9.52669C188.483 9.52669 190.567 11.7468 190.567 14.6161V23.3291H193.984V14.7862C193.984 10.0016 190.635 6.17534 185.852 6.17534C182.196 6.17534 180.488 8.42942 180.488 8.42942V0H177.071V23.3291ZM205.439 23.5686C206.578 23.5727 207.706 23.3479 208.757 22.9076C209.807 22.4673 210.759 21.8205 211.554 21.0055L209.061 18.5799C208.07 19.6049 206.805 20.1507 205.439 20.1507C203.149 20.1507 201.099 18.6139 200.553 16.3244H213.98C213.98 9.86693 210.222 6.17675 205.439 6.17675C200.656 6.17675 196.897 10.0044 196.897 14.8897C196.897 19.7409 200.656 23.5686 205.439 23.5686ZM200.553 13.0779C201.271 11.0294 202.945 9.59332 205.337 9.59332C207.728 9.59332 209.573 11.1315 210.086 13.0794H200.553V13.0779ZM217.059 23.3291H220.476V13.8307C220.579 11.4391 222.424 9.42178 224.781 9.42178C225.67 9.42178 226.524 9.73083 227.241 10.2086L228.54 6.92812C227.472 6.42371 226.304 6.16687 225.123 6.17675C221.946 6.17675 220.476 8.43084 220.476 8.43084V6.41776H217.059V23.3305V23.3291Z"
            fill="black"
          />
        </svg>
      </div>
      <div class="thankYou-body">
        <div class="thankYou-body-inner">
          <h2 id="TYNFontFamily">
            <span
              :style="{
                'font-family': tynData.HeadingFont,
              }"
            >
              Thank You!
            </span>
          </h2>
          <p v-html="tynData.Message"></p>
          <div class="thankYou-images">
            <span style="" v-for="item in tynData.Images">
              <img :src="item.Url" alt="" />
              <br />
            </span>
          </div>
        </div>
      </div>
      <div class="thankYou-footer">
        <svg
          width="181"
          height="26"
          viewBox="0 0 181 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.82153 25.8723C10.5844 25.8723 13.6442 22.7856 13.6442 19.0496V5.24481H10.9371V6.67921C10.9371 6.67921 9.39378 5.05386 6.79457 5.05386C2.95079 5.05386 0 8.11248 0 11.9574C0 15.8012 2.95079 18.8328 6.79569 18.8328C9.39378 18.8328 10.9371 17.2086 10.9371 17.2086V19.0507C10.9397 19.5919 10.8349 20.1281 10.629 20.6285C10.423 21.1289 10.12 21.5836 9.73727 21.9662C9.35458 22.3487 8.89987 22.6517 8.3994 22.8575C7.89894 23.0633 7.36265 23.1679 6.82153 23.1652C5.71175 23.1652 4.65589 22.7586 3.89882 21.9734L2.00276 23.8684C3.27541 25.168 4.98164 25.8723 6.82153 25.8723ZM6.79457 16.1258C4.5211 16.1258 2.70704 14.205 2.70704 11.9574C2.70704 9.68279 4.5211 7.7609 6.79569 7.7609C9.06916 7.7609 10.963 9.68279 10.963 11.9574C10.963 14.2039 9.06916 16.1258 6.79569 16.1258H6.79457ZM16.7657 18.6441H19.4727V11.1183C19.5536 9.22338 21.015 7.62499 22.8829 7.62499C23.5872 7.62499 24.2646 7.86873 24.8329 8.24839L25.8607 5.64918C25.0146 5.24957 24.0893 5.04607 23.1537 5.05386C20.6364 5.05386 19.4727 6.83983 19.4727 6.83983V5.24481H16.7657V18.6452V18.6441ZM32.9271 18.8328C36.717 18.8328 39.7228 15.8012 39.7228 11.9574C39.7228 8.08552 36.717 5.05386 32.9271 5.05386C29.1372 5.05386 26.1314 8.08665 26.1314 11.9574C26.1314 15.8012 29.1372 18.8328 32.9271 18.8328ZM32.9271 16.1258C30.6536 16.1258 28.8384 14.0961 28.8384 11.9574C28.8384 9.68279 30.7345 7.7609 32.9271 7.7609C35.1197 7.7609 37.0157 9.68279 37.0157 11.9574C37.0157 14.2039 35.0927 16.1258 32.9271 16.1258ZM48.3865 18.8328C52.1774 18.8328 54.6138 16.3695 54.6138 12.5797V5.24369H51.9067V12.7965C51.9067 14.9621 50.5521 16.3426 48.3865 16.3426C46.2208 16.3426 44.8673 14.961 44.8673 12.7965V5.24369H42.1602V12.5797C42.1602 16.3695 44.5977 18.8328 48.3865 18.8328ZM57.7297 25.6824H60.4367V17.2075C60.4367 17.2075 61.9801 18.8317 64.5793 18.8317C68.3692 18.8317 71.3739 15.8 71.3739 11.9293C71.3739 8.0844 68.3692 5.05273 64.5782 5.05273C61.9801 5.05273 60.4367 6.67696 60.4367 6.67696V5.24369H57.7297V25.6824ZM64.5782 16.1258C62.2508 16.1258 60.4098 14.2578 60.4098 11.9304C60.4098 9.68391 62.2508 7.7609 64.5793 7.7609C66.9067 7.7609 68.6668 9.68279 68.6668 11.9304C68.6668 14.2578 66.9067 16.1258 64.5782 16.1258Z"
            fill="black"
          />
          <path
            d="M25.3832 19.6172L25.7056 19.9295C27.6552 21.8114 30.2622 22.8584 32.9719 22.8477C35.6813 22.8581 38.2878 21.8111 40.2371 19.9295L40.5595 19.6172L42.5443 21.5424L42.2017 21.8749C39.7253 24.2656 36.4141 25.5963 32.9719 25.5839C29.5294 25.5967 26.2177 24.266 23.741 21.8749L23.3984 21.5424L25.3832 19.6172Z"
            fill="#7FE2DC"
          />
          <path
            d="M76.5981 18.5112H79.3051V7.6269H81.7684V5.05465H79.3051V0H76.5981V5.05689H74.1348V7.62915H76.5981V18.5112ZM90.1187 18.6741C93.9074 18.6741 96.9121 15.6413 96.9121 11.7975C96.9121 7.92569 93.9074 4.89402 90.1176 4.89402C86.3277 4.89402 83.3219 7.92681 83.3219 11.7975C83.3219 15.6413 86.3277 18.6741 90.1176 18.6741H90.1187ZM90.1187 15.9671C87.8441 15.9671 86.03 13.9362 86.03 11.7975C86.03 9.52295 87.925 7.60107 90.1187 7.60107C92.3102 7.60107 94.2051 9.52295 94.2051 11.7975C94.2051 14.0441 92.2843 15.9659 90.1176 15.9659L90.1187 15.9671ZM105.767 25.7113C109.53 25.7113 112.588 22.6257 112.588 18.8898V5.08385H109.881V6.51825C109.881 6.51825 108.339 4.89402 105.74 4.89402C101.896 4.89402 98.9441 7.95377 98.9441 11.7975C98.9441 15.6413 101.896 18.6741 105.74 18.6741C108.339 18.6741 109.881 17.0488 109.881 17.0488V18.8909C109.884 19.4319 109.779 19.9681 109.573 20.4684C109.367 20.9688 109.064 21.4233 108.682 21.8059C108.299 22.1885 107.845 22.4915 107.344 22.6973C106.844 22.9032 106.308 23.0079 105.767 23.0054C104.657 23.0054 103.601 22.5988 102.843 21.8147L100.948 23.7085C102.221 25.0081 103.926 25.7124 105.767 25.7124V25.7113ZM105.74 15.9659C103.465 15.9659 101.651 14.0452 101.651 11.7975C101.651 9.52295 103.465 7.60107 105.74 7.60107C108.013 7.60107 109.909 9.52295 109.909 11.7975C109.909 14.0441 108.013 15.9659 105.74 15.9659ZM121.871 18.6741C122.773 18.6772 123.667 18.4991 124.5 18.1503C125.332 17.8014 126.086 17.2889 126.717 16.6433L124.74 14.7214C123.954 15.5335 122.954 15.9659 121.871 15.9659C120.057 15.9659 118.433 14.7483 117.999 12.9343H128.407C128.407 7.81785 125.661 4.89402 121.871 4.89402C118.081 4.89402 115.102 7.92681 115.102 11.7975C115.102 15.6413 118.081 18.6741 121.871 18.6741ZM117.999 10.362C118.567 8.73892 119.894 7.60107 121.789 7.60107C123.684 7.60107 125.146 8.8198 125.552 10.3631H117.999V10.362ZM132.498 18.5112H135.205V7.6269H137.668V5.05465H135.205V0H132.498V5.05689H130.035V7.62915H132.498V18.5112ZM139.965 18.4843H142.672V11.446C142.672 9.30729 144.594 7.54827 146.733 7.54827C149.008 7.54827 150.659 9.30729 150.659 11.5808V18.4843H153.366V11.7155C153.366 7.92456 150.713 4.8929 146.923 4.8929C144.026 4.8929 142.672 6.67887 142.672 6.67887V0H139.965V18.4843ZM162.442 18.6741C163.344 18.6773 164.238 18.4992 165.071 18.1503C165.903 17.8015 166.657 17.289 167.287 16.6433L165.312 14.7214C164.526 15.5335 163.525 15.9659 162.442 15.9659C160.628 15.9659 159.003 14.7483 158.571 12.9343H169.209C169.209 7.81785 166.232 4.89402 162.442 4.89402C158.652 4.89402 155.674 7.92681 155.674 11.7975C155.674 15.6413 158.652 18.6741 162.442 18.6741ZM158.571 10.362C159.139 8.73892 160.466 7.60107 162.361 7.60107C164.256 7.60107 165.717 8.8198 166.124 10.3631H158.571V10.362ZM171.649 18.4843H174.356V10.9585C174.438 9.06354 175.899 7.46515 177.767 7.46515C178.472 7.46515 179.148 7.71002 179.716 8.08856L180.745 5.48935C179.899 5.08969 178.974 4.88619 178.038 4.89402C175.521 4.89402 174.356 6.68 174.356 6.68V5.08497H171.649V18.4854V18.4843Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  </div>

  <!--Thank you note present details Gift Recepient-->
  <div
    class="modal fade"
    id="sendThankYouNote"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-if="!thankYouPresent"
  >
    <div class="modal-dialog thank-you-modal modal-top-spacing">
      <div class="modal-content">
        <div class="gt-md-modal-header">
          <h2>Send a Thank you note</h2>
          <div class="gt-modal-close" data-dismiss="modal" @click="pauseVideo">
            <a href="javascript:void(0);">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
                width="14"
                height="14"
              >
                <path
                  stroke="#1e2437"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M 13 1 L 7 7 L 13 13"
                />
                <path
                  stroke="#1e2437"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M 1 13 L 7 7 L 1 1"
                />
              </svg>
            </a>
          </div>
        </div>
        <!-- gt-md-modal-header -->
        <div class="modal-body p-0">
          <div class="send-thank-you-body">
            <div class="d-md-none">
              <ul class="mobile-tab-thankyou">
                <li class="active thankyou-details" @click="thankYouForm">
                  Details
                </li>
                <li class="thankyou-preview" @click="thankYouFormPreview">
                  Preview
                </li>
              </ul>
            </div>
            <div class="row">
              <div class="col-md-6 thankYou-form">
                <div class="sign-body">
                  <div class="sign-message-block">
                    <div class="sign-from">
                      <label>Email subject line</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="subject"
                        placeholder="Type the subject line"
                      />
                    </div>
                    <!-- sign-from -->

                    <hr />

                    <div class="sign-from">
                      <label>Heading font</label>
                      <div class="position-relative">
                        <Select2
                          :options="fontOptions"
                           v-model="selectedOption"
                          :settings="{
                            minimumResultsForSearch: -1,
                            dropdownCssClass: 'select2-tyu with-font-family',
                            theme: 'select2-without-outline font-select2',
                            width: '100%',
                          }"
                          placeholder="Select font"
                        />
                      </div>
                    </div>
                    <!-- sign-from -->

                    <hr />

                    <div class="sign-from">
                      <label>Your message</label>
                      <div
                        id="TYNmessage"
                        class="textarea-block"
                        contenteditable="true"
                        @input="updateContent"
                        @paste="handlePaste"
                        placeholder="Type your message..."
                        aria-placeholder="Type your message..."
                      ></div>
                    </div>

                    <div class="inspiration-text">
                      <div class="inspiration-icon">
                        <span class="blob"></span>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.663 15H12.336M10 1V2M16.364 3.636L15.657 4.343M19 10H18M2 10H1M4.343 4.343L3.636 3.636M6.464 13.536C5.76487 12.8367 5.2888 11.9458 5.09598 10.9759C4.90316 10.006 5.00225 9.00076 5.38073 8.08721C5.75921 7.17366 6.40007 6.39284 7.22229 5.84349C8.0445 5.29414 9.01115 5.00093 10 5.00093C10.9889 5.00093 11.9555 5.29414 12.7777 5.84349C13.5999 6.39284 14.2408 7.17366 14.6193 8.08721C14.9977 9.00076 15.0968 10.006 14.904 10.9759C14.7112 11.9458 14.2351 12.8367 13.536 13.536L12.988 14.083C12.6747 14.3963 12.4262 14.7683 12.2567 15.1777C12.0872 15.5871 11.9999 16.0259 12 16.469V17C12 17.5304 11.7893 18.0391 11.4142 18.4142C11.0391 18.7893 10.5304 19 10 19C9.46957 19 8.96086 18.7893 8.58579 18.4142C8.21071 18.0391 8 17.5304 8 17V16.469C8 15.574 7.644 14.715 7.012 14.083L6.464 13.536Z"
                            stroke="#36ADB4"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </div>
                      Need some inspiration?
                      <a
                        href="javascript:void(0)"
                        data-toggle="modal"
                        data-target="#thankYouSuggestions"
                        >Click here</a
                      >
                    </div>
                    <!-- inspiration-text -->

                    <hr />

                    <div class="sign-from">
                      <label>From </label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Type who this message is from."
                        v-model="from"
                      />
                    </div>
                    <!-- sign-from -->
                  </div>
                  <!-- sign-message-block -->

                  <div class="add-image-block">
                    <div class="add-image-inner">
                      <div class="sign-file-upload mt-0">
                        <div class="upload-btn-wrapper">
                          <button class="outline-btn-dark">
                            Upload images
                          </button>
                          <input
                            ref="selectedImage"
                            type="file"
                            @change="handleFileSelect"
                            accept=".png, .jpg, .jpeg, .svg"
                          />
                        </div>

                        <span>Or</span>

                        <div class="upload-btn-wrapper">
                          <button
                            class="outline-btn-lite"
                            data-toggle="modal"
                            data-target="#giphyModal"
                          >
                            Add a GIF
                          </button>
                        </div>
                      </div>
                    </div>
                    <p class="uload-limit mb-0">
                      Upload limit of 5 images at 2mb each.
                    </p>

                    <div class="image-preview">
                      <div
                        v-for="(image, index) in thankYouImages"
                        :key="index"
                        class="position-relative"
                      >
                        <img
                          :src="image.url"
                          alt="Preview"
                          class="preview-image"
                        />
                        <span class="delete-image" @click="deleteImage(index)">
                          <svg
                            width="25"
                            height="23"
                            viewBox="0 0 25 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="0.539062"
                              width="23.9787"
                              height="23"
                              rx="11.5"
                              fill="white"
                            />
                            <path
                              d="M15.2283 16L17.0283 14.2L14.3283 11.5L17.0283 8.8L15.2283 7L12.5283 9.7L9.82832 7L8.02832 8.8L10.7283 11.5L8.02832 14.2L9.82832 16L12.5283 13.3L15.2283 16Z"
                              fill="#1E2437"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <!-- image-preview -->

                    <div
                      v-if="validationError"
                      class="warning-error w-100 mt-3"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 14H10V10H9M10 6H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
                              stroke="#F9A22E"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </div>
                        <div class="flex-grow-1">
                          <h4>Oops!</h4>
                          <p>{{ validationMessage }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- add-image-block -->
                </div>

                <div class="dropdown msg-group-dropdown thankYou-dropdown">
                  <button
                    class="theme-btn-lite dropdown-toggle pl-4 pr-4"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Share
                  </button>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      href="javascript:void(0);"
                      @click="savedToGroup"
                      >Send to group + organiser</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0);"
                      @click="shareByLink"
                      >Share using a link</a
                    >
                  </div>
                </div>
              </div>
              <!-- md-6 -->

              <div class="thankYou-form-preview col-md-6">
                <div class="preview-block">
                  <p>Preview</p>
                  <div class="thankYou-note-preview">
                    <h1 :style="{ fontFamily: 'Arial' }" id="fontDiv">
                      Thank You!
                    </h1>
                    <div class="thankYou-message" v-html="previewMessage"></div>
                    <div v-for="(image, index) in thankYouImages" :key="index">
                      <img
                        :src="image.url"
                        alt="Preview"
                        class="preview-image img-fluid w-100"
                      />
                    </div>
                    <img
                      class="img-fluid w-100 placeholder-thankyou"
                      :src="$getAssetUrlPlugin('siteres/placeholder-thankyou.png')"
                      alt="Preview"
                    />
                  </div>
                </div>
              </div>
              <!-- md-6 -->
            </div>
            <!-- row -->
          </div>
          <!-- -->
        </div>
        <!-- -->
      </div>
    </div>
  </div>
  <!-- Send thank you note Modal -->
  <!-- giphyModal -->
  <div
    class="modal fade"
    id="giphyModal"
    tabindex="-1"
    aria-labelledby="giphyModal"
    aria-hidden="true"
    v-if="!thankYouPresent"
  >
    <div class="modal-dialog modal-575 modal-top-spacing">
      <div class="modal-content">
        <div class="gt-md-modal-header">
          <h2>Add a GIF</h2>
          <div class="gt-modal-close" data-dismiss="modal">
            <a href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
                width="14"
                height="14"
              >
                <path
                  stroke="#1e2437"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M 13 1 L 7 7 L 13 13"
                />
                <path
                  stroke="#1e2437"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M 1 13 L 7 7 L 1 1"
                />
              </svg>
            </a>
          </div>
        </div>
        <!-- gt-md-modal-header -->
        <div class="modal-body theme-tabs">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="giphy-tab"
                data-toggle="tab"
                data-target="#giphy-tab-pane"
                type="button"
                role="tab"
                aria-controls="giphy-tab-pane"
                aria-selected="true"
              >
                Giphy
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="unsplash-tab"
                data-toggle="tab"
                data-target="#unsplash-tab-pane"
                type="button"
                role="tab"
                aria-controls="unsplash-tab-pane"
                aria-selected="false"
              >
                Unsplash
              </button>
            </li>
          </ul>
          <div class="tab-content">
            <GiphyModal @select-image="selectImage" v-if="!thankYouPresent" />
            <SplashModal @select-image="selectImage" v-if="!thankYouPresent" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- giphyModal -->
  <!-- show if TYN send by mail -->
  <div class="preloader d-none" id="DivSendBYMail" v-if="!thankYouPresent">
    <div class="preloader-top">
      <div class="preloader-logo mb-70 text-center d-none d-lg-block">
        <svg
          width="199"
          height="73"
          viewBox="0 0 199 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.0238 33.515C17.0818 33.515 22.0066 28.5466 22.0066 22.5322V0.305078H17.6484V2.61495C17.6484 2.61495 15.1642 0 10.9802 0C4.79151 0 0.0410156 4.92483 0.0410156 11.1135C0.0410156 17.3023 4.79151 22.1835 10.9802 22.1835C15.1642 22.1835 17.6484 19.5686 17.6484 19.5686V22.5322C17.6484 26.2367 14.6847 29.1567 11.0238 29.1567C9.23693 29.1567 7.53721 28.503 6.3169 27.2391L3.26612 30.2899C5.3145 32.3818 8.0602 33.515 11.0238 33.515ZM10.9802 17.8253C7.3193 17.8253 4.39927 14.7309 4.39927 11.1135C4.39927 7.45261 7.3193 4.35825 10.9802 4.35825C14.6412 4.35825 17.6919 7.45261 17.6919 11.1135C17.6919 14.7309 14.6412 17.8253 10.9802 17.8253Z"
            fill="#1E2437"
          ></path>
          <path
            d="M27.0315 21.8784H31.3898V9.76249C31.5205 6.71171 33.874 4.14034 36.8812 4.14034C38.0143 4.14034 39.1039 4.53258 40.0191 5.14274L41.6753 0.958816C40.4114 0.348661 38.9296 0 37.317 0C33.2638 0 31.3898 2.87645 31.3898 2.87645V0.305078H27.0315V21.8784Z"
            fill="#1E2437"
          ></path>
          <path
            d="M53.051 22.1835C59.1526 22.1835 63.9902 17.3023 63.9902 11.1135C63.9902 4.88124 59.1526 0 53.051 0C46.9494 0 42.1118 4.88124 42.1118 11.1135C42.1118 17.3023 46.9494 22.1835 53.051 22.1835ZM53.051 17.8253C49.3901 17.8253 46.47 14.5566 46.47 11.1135C46.47 7.45261 49.5208 4.35825 53.051 4.35825C56.5812 4.35825 59.632 7.45261 59.632 11.1135C59.632 14.7309 56.5376 17.8253 53.051 17.8253Z"
            fill="#1E2437"
          ></path>
          <path
            d="M77.9397 22.1835C84.0412 22.1835 87.9637 18.2175 87.9637 12.1159V0.305078H83.6054V12.4646C83.6054 15.9512 81.4263 18.1739 77.9397 18.1739C74.4531 18.1739 72.274 15.9512 72.274 12.4646V0.305078H67.9157V12.1159C67.9157 18.2175 71.8381 22.1835 77.9397 22.1835Z"
            fill="#1E2437"
          ></path>
          <path
            d="M92.9808 33.2099H97.339V19.5686C97.339 19.5686 99.8232 22.1835 104.007 22.1835C110.109 22.1835 114.946 17.3023 114.946 11.07C114.946 4.88124 110.109 0 104.007 0C99.8232 0 97.339 2.61495 97.339 2.61495V0.305078H92.9808V33.2099ZM104.007 17.8253C100.259 17.8253 97.2954 14.8181 97.2954 11.07C97.2954 7.45261 100.259 4.35825 104.007 4.35825C107.755 4.35825 110.588 7.45261 110.588 11.07C110.588 14.8181 107.755 17.8253 104.007 17.8253Z"
            fill="#1E2437"
          ></path>
          <path
            d="M40.9056 23.4473L41.4243 23.9504C44.4151 26.8512 48.5495 28.6483 53.1222 28.6483C57.695 28.6483 61.8294 26.8512 64.8202 23.9504L65.3389 23.4473L68.5336 26.5459L67.9822 27.0807C64.1762 30.7722 58.921 33.0526 53.1222 33.0526C47.3235 33.0526 42.0683 30.7722 38.2623 27.0807L37.7109 26.5459L40.9056 23.4473Z"
            fill="white"
          ></path>
          <path
            d="M31.2912 61.4075H35.6495V43.8873H39.6155V39.747H35.6495V29.7979H31.2912V39.747H27.3252V43.8873H31.2912V61.4075Z"
            fill="#1E2437"
          ></path>
          <path
            d="M53.0563 61.669C59.1578 61.669 63.9955 56.7877 63.9955 50.599C63.9955 44.3667 59.1578 39.4855 53.0563 39.4855C46.9547 39.4855 42.1171 44.3667 42.1171 50.599C42.1171 56.7877 46.9547 61.669 53.0563 61.669ZM53.0563 57.3107C49.3953 57.3107 46.4753 54.042 46.4753 50.599C46.4753 46.9381 49.5261 43.8437 53.0563 43.8437C56.5865 43.8437 59.6372 46.9381 59.6372 50.599C59.6372 54.2164 56.5429 57.3107 53.0563 57.3107Z"
            fill="#1E2437"
          ></path>
          <path
            d="M78.25 73.0004C84.308 73.0004 89.2328 68.032 89.2328 62.0176V39.7905H84.8746V42.1004C84.8746 42.1004 82.3904 39.4855 78.2065 39.4855C72.0177 39.4855 67.2672 44.4103 67.2672 50.599C67.2672 56.7877 72.0177 61.669 78.2065 61.669C82.3904 61.669 84.8746 59.054 84.8746 59.054V62.0176C84.8746 65.7222 81.911 68.6422 78.25 68.6422C76.4632 68.6422 74.7634 67.9884 73.5431 66.7245L70.4923 69.7753C72.5407 71.8673 75.2864 73.0004 78.25 73.0004ZM78.2065 57.3107C74.5455 57.3107 71.6255 54.2164 71.6255 50.599C71.6255 46.9381 74.5455 43.8437 78.2065 43.8437C81.8674 43.8437 84.9182 46.9381 84.9182 50.599C84.9182 54.2164 81.8674 57.3107 78.2065 57.3107Z"
            fill="#1E2437"
          ></path>
          <path
            d="M104.176 61.669C107.27 61.669 110.016 60.4051 111.977 58.4003L108.795 55.3059C107.531 56.6134 105.919 57.3107 104.176 57.3107C101.255 57.3107 98.6405 55.3495 97.9432 52.4295H114.699C114.699 44.1924 110.277 39.4855 104.176 39.4855C98.074 39.4855 93.2799 44.3667 93.2799 50.599C93.2799 56.7877 98.074 61.669 104.176 61.669ZM97.9432 48.2891C98.8585 45.6742 100.994 43.8437 104.045 43.8437C107.096 43.8437 109.449 45.8049 110.103 48.2891H97.9432Z"
            fill="#1E2437"
          ></path>
          <path
            d="M121.285 61.4075H125.643V43.8873H129.609V39.747H125.643V29.7979H121.285V39.747H117.319V43.8873H121.285V61.4075Z"
            fill="#1E2437"
          ></path>
          <path
            d="M133.306 61.3639H137.665V50.0324C137.665 46.5894 140.759 43.7566 144.202 43.7566C147.863 43.7566 150.521 46.5894 150.521 50.2504V61.3639H154.88V50.4683C154.88 44.3667 150.609 39.4855 144.507 39.4855C139.844 39.4855 137.665 42.3619 137.665 42.3619V29.7979H133.306V61.3639Z"
            fill="#1E2437"
          ></path>
          <path
            d="M169.492 61.669C172.586 61.669 175.332 60.4051 177.293 58.4003L174.112 55.3059C172.848 56.6134 171.235 57.3107 169.492 57.3107C166.572 57.3107 163.957 55.3495 163.259 52.4295H180.387C180.387 44.1924 175.593 39.4855 169.492 39.4855C163.39 39.4855 158.596 44.3667 158.596 50.599C158.596 56.7877 163.39 61.669 169.492 61.669ZM163.259 48.2891C164.175 45.6742 166.31 43.8437 169.361 43.8437C172.412 43.8437 174.765 45.8049 175.419 48.2891H163.259Z"
            fill="#1E2437"
          ></path>
          <path
            d="M184.315 61.3639H188.673V49.2479C188.804 46.1972 191.157 43.6258 194.165 43.6258C195.298 43.6258 196.387 44.018 197.303 44.6282L198.959 40.4443C197.695 39.8341 196.213 39.4855 194.6 39.4855C190.547 39.4855 188.673 42.3619 188.673 42.3619V39.7905H184.315V61.3639Z"
            fill="#1E2437"
          ></path>
        </svg>
      </div>
      <div class="preloader-inner mx-auto">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <img
              class="loader-image mr-20"
              :src="$getAssetUrlPlugin('siteres/Receipt_page_GIFv7.gif')"
              alt="sheep_GIF_alpha_small"
            />
          </div>
          <div class="flex-grow-1 ms-3">
            <div class="loader-dialogue position-relative">
              <h2>Success!</h2>
              <p>Thank you note sent successfully to the group.</p>

              <div class="preload-button-group">
                <a
                  :href="thankYouNoteURl"
                  target="_blank"
                  class="theme-btn-lite"
                  >View</a
                >
                <a
                  href="javascript:void(0)"
                  class="theme-btn-lite"
                  @click="CloseSendBYMailDiv"
                  >Close</a
                >
              </div>

              <!-- dialogue-bubble -->
              <svg
                class="dialogue-bubble"
                width="48"
                height="62"
                viewBox="0 0 48 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.0312 45.4905C33.926 52.0426 35.9722 58.5609 36.3102 61.501L47.3102 25.96C43.7614 14.8298 36.3102 -5.05103 36.3102 1.50113C36.3102 8.05329 32.8102 12.0011 30.0731 12.7297C27.7072 13.1497 20.0349 13.7377 8.27314 12.7297C-3.48864 11.7217 -0.467985 19.501 3.71038 23.4399C8.61112 28.0601 20.1363 38.9383 27.0312 45.4905Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- show if TYN send without mail -->
  <div class="preloader d-none" id="DivSendWithoutMail" v-if="!thankYouPresent">
    <div class="preloader-top">
      <div class="preloader-logo mb-70 text-center d-none d-lg-block">
        <svg
          width="199"
          height="73"
          viewBox="0 0 199 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.0238 33.515C17.0818 33.515 22.0066 28.5466 22.0066 22.5322V0.305078H17.6484V2.61495C17.6484 2.61495 15.1642 0 10.9802 0C4.79151 0 0.0410156 4.92483 0.0410156 11.1135C0.0410156 17.3023 4.79151 22.1835 10.9802 22.1835C15.1642 22.1835 17.6484 19.5686 17.6484 19.5686V22.5322C17.6484 26.2367 14.6847 29.1567 11.0238 29.1567C9.23693 29.1567 7.53721 28.503 6.3169 27.2391L3.26612 30.2899C5.3145 32.3818 8.0602 33.515 11.0238 33.515ZM10.9802 17.8253C7.3193 17.8253 4.39927 14.7309 4.39927 11.1135C4.39927 7.45261 7.3193 4.35825 10.9802 4.35825C14.6412 4.35825 17.6919 7.45261 17.6919 11.1135C17.6919 14.7309 14.6412 17.8253 10.9802 17.8253Z"
            fill="#1E2437"
          ></path>
          <path
            d="M27.0315 21.8784H31.3898V9.76249C31.5205 6.71171 33.874 4.14034 36.8812 4.14034C38.0143 4.14034 39.1039 4.53258 40.0191 5.14274L41.6753 0.958816C40.4114 0.348661 38.9296 0 37.317 0C33.2638 0 31.3898 2.87645 31.3898 2.87645V0.305078H27.0315V21.8784Z"
            fill="#1E2437"
          ></path>
          <path
            d="M53.051 22.1835C59.1526 22.1835 63.9902 17.3023 63.9902 11.1135C63.9902 4.88124 59.1526 0 53.051 0C46.9494 0 42.1118 4.88124 42.1118 11.1135C42.1118 17.3023 46.9494 22.1835 53.051 22.1835ZM53.051 17.8253C49.3901 17.8253 46.47 14.5566 46.47 11.1135C46.47 7.45261 49.5208 4.35825 53.051 4.35825C56.5812 4.35825 59.632 7.45261 59.632 11.1135C59.632 14.7309 56.5376 17.8253 53.051 17.8253Z"
            fill="#1E2437"
          ></path>
          <path
            d="M77.9397 22.1835C84.0412 22.1835 87.9637 18.2175 87.9637 12.1159V0.305078H83.6054V12.4646C83.6054 15.9512 81.4263 18.1739 77.9397 18.1739C74.4531 18.1739 72.274 15.9512 72.274 12.4646V0.305078H67.9157V12.1159C67.9157 18.2175 71.8381 22.1835 77.9397 22.1835Z"
            fill="#1E2437"
          ></path>
          <path
            d="M92.9808 33.2099H97.339V19.5686C97.339 19.5686 99.8232 22.1835 104.007 22.1835C110.109 22.1835 114.946 17.3023 114.946 11.07C114.946 4.88124 110.109 0 104.007 0C99.8232 0 97.339 2.61495 97.339 2.61495V0.305078H92.9808V33.2099ZM104.007 17.8253C100.259 17.8253 97.2954 14.8181 97.2954 11.07C97.2954 7.45261 100.259 4.35825 104.007 4.35825C107.755 4.35825 110.588 7.45261 110.588 11.07C110.588 14.8181 107.755 17.8253 104.007 17.8253Z"
            fill="#1E2437"
          ></path>
          <path
            d="M40.9056 23.4473L41.4243 23.9504C44.4151 26.8512 48.5495 28.6483 53.1222 28.6483C57.695 28.6483 61.8294 26.8512 64.8202 23.9504L65.3389 23.4473L68.5336 26.5459L67.9822 27.0807C64.1762 30.7722 58.921 33.0526 53.1222 33.0526C47.3235 33.0526 42.0683 30.7722 38.2623 27.0807L37.7109 26.5459L40.9056 23.4473Z"
            fill="white"
          ></path>
          <path
            d="M31.2912 61.4075H35.6495V43.8873H39.6155V39.747H35.6495V29.7979H31.2912V39.747H27.3252V43.8873H31.2912V61.4075Z"
            fill="#1E2437"
          ></path>
          <path
            d="M53.0563 61.669C59.1578 61.669 63.9955 56.7877 63.9955 50.599C63.9955 44.3667 59.1578 39.4855 53.0563 39.4855C46.9547 39.4855 42.1171 44.3667 42.1171 50.599C42.1171 56.7877 46.9547 61.669 53.0563 61.669ZM53.0563 57.3107C49.3953 57.3107 46.4753 54.042 46.4753 50.599C46.4753 46.9381 49.5261 43.8437 53.0563 43.8437C56.5865 43.8437 59.6372 46.9381 59.6372 50.599C59.6372 54.2164 56.5429 57.3107 53.0563 57.3107Z"
            fill="#1E2437"
          ></path>
          <path
            d="M78.25 73.0004C84.308 73.0004 89.2328 68.032 89.2328 62.0176V39.7905H84.8746V42.1004C84.8746 42.1004 82.3904 39.4855 78.2065 39.4855C72.0177 39.4855 67.2672 44.4103 67.2672 50.599C67.2672 56.7877 72.0177 61.669 78.2065 61.669C82.3904 61.669 84.8746 59.054 84.8746 59.054V62.0176C84.8746 65.7222 81.911 68.6422 78.25 68.6422C76.4632 68.6422 74.7634 67.9884 73.5431 66.7245L70.4923 69.7753C72.5407 71.8673 75.2864 73.0004 78.25 73.0004ZM78.2065 57.3107C74.5455 57.3107 71.6255 54.2164 71.6255 50.599C71.6255 46.9381 74.5455 43.8437 78.2065 43.8437C81.8674 43.8437 84.9182 46.9381 84.9182 50.599C84.9182 54.2164 81.8674 57.3107 78.2065 57.3107Z"
            fill="#1E2437"
          ></path>
          <path
            d="M104.176 61.669C107.27 61.669 110.016 60.4051 111.977 58.4003L108.795 55.3059C107.531 56.6134 105.919 57.3107 104.176 57.3107C101.255 57.3107 98.6405 55.3495 97.9432 52.4295H114.699C114.699 44.1924 110.277 39.4855 104.176 39.4855C98.074 39.4855 93.2799 44.3667 93.2799 50.599C93.2799 56.7877 98.074 61.669 104.176 61.669ZM97.9432 48.2891C98.8585 45.6742 100.994 43.8437 104.045 43.8437C107.096 43.8437 109.449 45.8049 110.103 48.2891H97.9432Z"
            fill="#1E2437"
          ></path>
          <path
            d="M121.285 61.4075H125.643V43.8873H129.609V39.747H125.643V29.7979H121.285V39.747H117.319V43.8873H121.285V61.4075Z"
            fill="#1E2437"
          ></path>
          <path
            d="M133.306 61.3639H137.665V50.0324C137.665 46.5894 140.759 43.7566 144.202 43.7566C147.863 43.7566 150.521 46.5894 150.521 50.2504V61.3639H154.88V50.4683C154.88 44.3667 150.609 39.4855 144.507 39.4855C139.844 39.4855 137.665 42.3619 137.665 42.3619V29.7979H133.306V61.3639Z"
            fill="#1E2437"
          ></path>
          <path
            d="M169.492 61.669C172.586 61.669 175.332 60.4051 177.293 58.4003L174.112 55.3059C172.848 56.6134 171.235 57.3107 169.492 57.3107C166.572 57.3107 163.957 55.3495 163.259 52.4295H180.387C180.387 44.1924 175.593 39.4855 169.492 39.4855C163.39 39.4855 158.596 44.3667 158.596 50.599C158.596 56.7877 163.39 61.669 169.492 61.669ZM163.259 48.2891C164.175 45.6742 166.31 43.8437 169.361 43.8437C172.412 43.8437 174.765 45.8049 175.419 48.2891H163.259Z"
            fill="#1E2437"
          ></path>
          <path
            d="M184.315 61.3639H188.673V49.2479C188.804 46.1972 191.157 43.6258 194.165 43.6258C195.298 43.6258 196.387 44.018 197.303 44.6282L198.959 40.4443C197.695 39.8341 196.213 39.4855 194.6 39.4855C190.547 39.4855 188.673 42.3619 188.673 42.3619V39.7905H184.315V61.3639Z"
            fill="#1E2437"
          ></path>
        </svg>
      </div>
      <div class="preloader-inner mx-auto">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <img
              class="loader-image mr-20"
              :src="$getAssetUrlPlugin('siteres/Receipt_page_GIFv7.gif')"
              alt="sheep_GIF_alpha_small"
            />
          </div>
          <div class="flex-grow-1 ms-3">
            <div class="loader-dialogue position-relative">
              <h2>Your Thank You Note is ready! 🎉</h2>
              <p>Copy the link below to share it with your group.</p>

              <div class="share-link">
                <input
                  id="TYNurl"
                  type="text"
                  @click="copyTYNurl"
                  :value="thankYouNoteURl"
                  readonly
                />
                <button id="btnCopyUrl2" @click="copyTYNurl">Copy</button>
              </div>

              <div class="preload-button-group">
                <a
                  href="javascript:void(0)"
                  class="theme-btn-lite"
                  @click="CloseSendBYMailDiv"
                  >Close</a
                >
              </div>

              <!-- dialogue-bubble -->
              <svg
                class="dialogue-bubble"
                width="48"
                height="62"
                viewBox="0 0 48 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.0312 45.4905C33.926 52.0426 35.9722 58.5609 36.3102 61.501L47.3102 25.96C43.7614 14.8298 36.3102 -5.05103 36.3102 1.50113C36.3102 8.05329 32.8102 12.0011 30.0731 12.7297C27.7072 13.1497 20.0349 13.7377 8.27314 12.7297C-3.48864 11.7217 -0.467985 19.501 3.71038 23.4399C8.61112 28.0601 20.1363 38.9383 27.0312 45.4905Z"
                  fill="white"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <SuggestionsModal
    @select-suggestion="InsertSuggestion"
    v-if="!thankYouPresent"
  />
  <!-- imageCropperContainer -->
  <ImageCropper
    @thankyouImageUrl="thankyouImageUrl"
    :collection="collectionGuid"
    :cropperContainers="cropperContainers"
    v-if="!thankYouPresent"
  />
</template>
<!-- template html -->
<!-- script -->
<script>
import Select2 from "vue3-select2-component";
import DatePicker from "vue3-datepicker";
import ImageCropper from "../common/ImageCropper.vue";
import SplashModal from "./SplashModal.vue";
import GiphyModal from "./GiphyModal.vue";
import SuggestionsModal from "./SuggestionsModal.vue";
import { String } from "core-js";
import Constants from "../constants/Constants.js";
export default {
  name: "ThankYouNote",
  components: {
    SplashModal,
    GiphyModal,
    SuggestionsModal,
    Select2,
    DatePicker,
    ImageCropper,
    Constants,
  },
  props: {
    collectionGuid: String,
    giftId: String,
    callingFrom: String,
  },
  data: function () {
    return {
      thankYouPresent: false,
      tynData: null,
      collectionId: "",
      template: "",
      cardUrl: "",
      from: "",
      thankYouNoteLoader: false,
      subject: "",
      videoPlaying: false,
      selectedOption: "font1",
      font: "Arial",
      thankYouImages: [],
      thankyouNoteImageUrl: {},
      content: "",
      previewMessage: "Your message will display here...",
      validationError: false,
      validationMessage: false,
      ThankYouNoteURl: "",
      fontOptions: Constants.FONTS,
      formatForInput: "dd MMM yyyy",
      cropperContainers: "thankyouNoteContainer",
    };
  },
  mounted: function () {
    this.isThankYouNotePresent();
  },
  methods: {
    isThankYouNotePresent() {
      var requestId = "";
      this.thankYouNoteLoader = true;
      switch (this.callingFrom) {
        case "GiftRecipientPath":
          requestId = this.giftId;
          break;

        case "PGCRecipientPath":
          requestId = this.collectionGuid;
          break;
      }
      $.ajax({
        url: "/ThankYou/IsThankYouNotePresent",
        data: { requestId: requestId, requestedFromPage: this.callingFrom },
        success: (data) => {
          // Use arrow function here
          // Call successful
          if (!data.error && data.result) {
            this.thankYouPresent = true;
          } else if (!data.error && !data.result) {
            this.thankYouPresent = false;
          } else if (data.error) {
            console.log("Error", data.message);
          }
        },
        error: (xhr) => {
          // Use arrow function here
          this.thankYouNoteLoader = false;
        },
        complete: () => {
          // Use arrow function here
          this.thankYouNoteLoader = false;
          if (this.thankYouPresent) {
            this.getThankYouNoteData();
          } else {
            $("#select2--container").on("DOMSubtreeModified", function () {
              setTimeout(function () {
                this.font = $("#select2--container").text();
                var fonts = $("#select2--container").text();
                $("#fontDiv").css("fontFamily", fonts);
              }, 200);
            });
          }
        },
      });
    },
    copyGifturl() {
      if (this.tynData.NoteURL)
        navigator.clipboard.writeText(this.tynData.NoteURL);
      $("#btnCopyUrl").html("Copied");
    },
    getThankYouNoteData() {
      var requestId = "";
      this.thankYouNoteLoader = true;
      switch (this.callingFrom) {
        case "GiftRecipientPath":
          requestId = this.giftId;
          break;

        case "PGCRecipientPath":
          requestId = this.collectionGuid;
          break;
      }
      $.ajax({
        url: "/ThankYou/GetThankYouNote",
        data: { requestId: requestId, requestedFromPage: this.callingFrom },
        success: (data) => {
          // Use arrow function here
          // Call successful
          if (data.result) {
            this.tynData = data.response;
            this.thankYouNoteLoader = false;
          } else {
            this.thankYouNoteLoader = false;
          }
        },
        error: (xhr) => {
          // Use arrow function here
          this.thankYouNoteLoader = false;
        },
        complete: () => {
          // Use arrow function here
          this.thankYouNoteLoader = false;
        },
      });
    },
    thankyouImageUrl(imageUrl) {
      this.thankyouNoteImageUrl = { imageUrl: imageUrl };
    },
    checkUserCropperContainer(containerObject) {
      this.cropperContainer = containerObject;
    },
    formatDateString(dateString) {
      // Check if dateString is valid
      if (!dateString || typeof dateString !== "string") return "";

      // Extract the timestamp using regex
      const matches = dateString.match(/\/Date\((\d+)\)\//);
      if (!matches || matches.length < 2) return "";

      const timestamp = parseInt(matches[1], 10);
      if (isNaN(timestamp)) return "";

      // Create a Date object
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return "";

      // Format the date as dd/mm/yyyy
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    selectImage(imageUrl) {
      // hide placeholder
      $(".placeholder-thankyou").addClass("d-none");

      if (this.thankYouImages.length >= 5) {
        this.validationError = true;
        this.validationMessage = "You can only select up to 5 images.";
        $("#giphyModal").modal("hide");
        return;
      }
      this.validationError = false;
      this.validationMessage = "";
      this.thankYouImages.push({ url: imageUrl, file: null, type: "Gif" });
      $("#giphyModal").modal("hide");
    },
    sendRecipientThankYouNote() {
      $("#RecipientThankYou").modal();
    },
    handleFileSelect(event) {
      if (this.cropperContainers) {
        this.checkUserCropperContainer();
      }
      const files = event.target.files;
      const remainingSlots = 5 - this.thankYouImages.length;
      if (files.length > remainingSlots) {
        this.validationError = true;
        this.validationMessage = "You can only select up to 5 images.";
        return;
      }
      this.validationError = false;
      this.validationMessage = "";
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          if (file.size) {
            var mbs = file.size / 1048576;
            if (mbs > 2) {
              this.validationError = true;
              this.validationMessage =
                "Image size should not be greater than 2mb.";
              return;
            } else {
              $("#imageCropperContainer").modal("show");
              let reader = new FileReader();
              reader.addEventListener(
                "load",
                function () {
                  window.src = reader.result;
                  $(".message_upload_image_input").val("");
                },
                false
              );
              if (file) {
                reader.readAsDataURL(file);
              }
            }
          }
        };
        reader.readAsDataURL(file);
      }
      // hide placeholder
      $(".placeholder-thankyou").addClass("d-none");
    },
    // delete image
    deleteImage(index) {
      this.thankYouImages.splice(index, 1);
      this.$refs.selectedImage.value = "";
    },
    updateContent(event) {
      this.content = event.target.innerHTML;

      this.updatePreview();
    },
    handlePaste(event) {
      // Handle paste event separately to capture the pasted content
      const pastedContent = (
        event.clipboardData || window.clipboardData
      ).getData("text/html");
      this.content = pastedContent;
      this.updatePreview();
    },
    updatePreview() {
      // Update the preview by setting the content as HTML
      this.previewMessage = event.target.innerHTML;
    },
    thankYouFormPreview() {
      $(".thankYou-form-preview").addClass("d-block");
      $(".thankYou-form-preview").removeClass("d-none");
      $(".thankYou-form").addClass("d-none");
      $(".thankYou-form").removeClass("d-block");

      $("li.thankyou-details").removeClass("active");
      $("li.thankyou-preview").addClass("active");
    },
    thankYouForm() {
      $(".thankYou-form").addClass("d-block");
      $(".thankYou-form").removeClass("d-none");
      $(".thankYou-form-preview").addClass("d-none");
      $(".thankYou-form-preview").removeClass("d-block");

      $("li.thankyou-details").addClass("active");
      $("li.thankyou-preview").removeClass("active");
    },
    async savedData(sendByEmail) {
      if (!this.subject) {
        this.validationError = true;
        this.validationMessage = "Please enter  subject.";
        return;
      }

      if (!this.content) {
        this.validationError = true;
        this.validationMessage = "Please enter Thankyou message.";
        return;
      }
      if (!this.from) {
        this.validationError = true;
        this.validationMessage = "From is required.";
        return;
      }
      var images = [];

      $.each(this.thankYouImages, function (Index, value) {
        images.push({ Position: Index, Url: value.url });
      });
      var thankYouModel = {
        HeadingFont: $("#select2--container").text(),
        GiftID: this.giftId,
        Message: this.content,
        SendByEmail: sendByEmail,
        Subject: this.subject,
        Images: images,
        From: this.from,
        CollectionGuid: this.collectionGuid,
        TYNFromPath: this.callingFrom,
      };
      this.thankYouNoteLoader = true;
      var vueObj = this;
        $.ajax({
            type: "POST",
            url: "/ThankYou/SavedThankYouNote",
            data: JSON.stringify(thankYouModel),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                // call successful
                if (data.result) {
                    if (sendByEmail) {
                        vueObj.OpenSendBYMailDiv(data.url);
                    } else {
                        vueObj.OpenSendWithoutMailDiv(data.url);
                    }
                }
            },
            error: function (xhr) {
                // handle error
            }
        });

    },
    async savedToGroup() {
      await this.savedData(true);
    },
    async shareByLink() {
      await this.savedData(false);
    },
    copyTYNurl() {
      if (this.thankYouNoteURl)
        navigator.clipboard.writeText(this.thankYouNoteURl);
      $("#btnCopyUrl2").html("Copied");
    },
    OpenSendBYMailDiv(url) {
      this.thankYouNoteURl = url;
      this.thankYouNoteLoader = false;
      $("#sendThankYouNote").modal("hide");
      $("#DivSendBYMail").removeClass("d-none");
    },
    OpenSendWithoutMailDiv(url) {
      this.thankYouNoteLoader = false;
      this.thankYouNoteURl = url;

      $("#sendThankYouNote").modal("hide");
      $("#DivSendWithoutMail").removeClass("d-none");
    },
    CloseSendBYMailDiv() {
      location.reload();
    },
    InsertSuggestion(suggestion) {
      var tynMessage = $("#TYNmessage").html() + " " + suggestion;
      $("#TYNmessage").html(tynMessage);
      this.content = tynMessage;
      this.previewMessage = tynMessage;
      $("#thankYouSuggestions").modal("hide");
      this.UpdateFontStyle();
    },
   UpdateFontStyle() {
   this.font = $("#select2--container").text();

   var fonts = $("#select2--container").text();
   $("#fontDiv").css("fontFamily", fonts);
   },
  },
  watch: {
    thankyouNoteImageUrl(val) {
      this.thankYouImages.push({
        url: val.imageUrl.data,
        file: val.imageUrl.fileCover,
        type: "Image",
      });
    },
    selectedOption(old,newVal){
        if (old != newVal){
            this.UpdateFontStyle()
        }

    }
  },
};
</script>
